import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

// Config and data
import { onlineCityCode } from '~/data/fakeCities'; // its not fake, its real

import decl from '~/helpers/decl';
import price from '~/helpers/price';
import {
  getSingleDate,
  getIsDatesShown,
  getDates,
} from '~/helpers/calendar';

// components
import { DateCalendar } from '~c/Calendar/DateCalendar';
import useWindowDimensions from '../../../hooks/windowDimensions';
import CloseSubPopup from '~c/popups/CloseSubPopup';
import ShowMoreButton from '~c/popups/ShowMoreButton';

const Card = props => {

  const singleDaysStr = getSingleDate(props.START_DATE, props.END_DATE, props.EVENT_DAYS);

  // FIXME: find custom field
  const description = props.DESCRIPTION;

  const title = props.SHORT_NAME;

  const btn = props.EVENT_PAGE ? (
    <a
      className="btn btn--primary course-reg__btn"
      href={
        `${props.EVENT_PAGE.DETAIL_PAGE_URL}registration/${props.CODE.toLowerCase()}/`
      }
    >
      {props?.BUTTONS || 'Зарегистрироваться'}
    </a>
  ) : null;

  const eventPrice = props.PRICE_WITH_VAT || props.PRICE || 0;
  const examPrice = props.EXAM_PRICE || 0;
  const totalPrice = Number(examPrice) + Number(eventPrice);
  const priceStr = totalPrice ? price(totalPrice, +props.VAT > 0) : 'Бесплатно';

  const titleClasses = ['title'];
  if (props.CITY_CODE == onlineCityCode) titleClasses.push('online-tag');

  const dateString = singleDaysStr || '';

  const isDatesShown = getIsDatesShown(props.START_DATE, props.END_DATE, props.EVENT_DAYS);

  let datesForCalendar = [];
  if (isDatesShown) {
    datesForCalendar = getDates(props.START_DATE, props.END_DATE, props.EVENT_DAYS);
  }

  const { width } = useWindowDimensions();

  const [isDescShown, setIsDescShown] = useState(false);

  const onShowMoreClick = () => {
    setIsDescShown(true);
  };

  const onCloseDescClick = () => {
    setIsDescShown(false);
  };

  const getDescriptionMaxHeightByScreenWidth = (width) => {
    return width > 768 ? 115 : 100;
  };
  const [isConditionForHiddenDescription, setIsConditionForHiddenDescription] = useState(false);

  const uniqueId = `${Date.now().toString(36)}-${Math.floor(
    Math.random() * 1e16,
  ).toString(36)}`;

  useEffect(() => {
    const paragraph = document.getElementsByClassName(`txt ${uniqueId}`);
    if (paragraph[0].clientHeight >= getDescriptionMaxHeightByScreenWidth(width) !== isConditionForHiddenDescription) {
      setIsConditionForHiddenDescription(paragraph[0].clientHeight >= getDescriptionMaxHeightByScreenWidth(width));
    }
  }, [width]);

  return (
    <div className="course-reg__item">
      <div className="course-reg__cell reg-main">
        <p className={titleClasses.join(' ')}>{`${title} `}</p>
        <div className="txt course-reg__dates">
          <span
            className="course-reg__dates reg-date"
          >{props.productCard ? 'В любое время' : dateString}</span>
          {
            isDatesShown &&
            <DateCalendar
              dates={datesForCalendar}
              setCardIdCalendarClicked={props.setCardIdCalendarClicked}
              cardId={props.id}
              cardIdCalendarClicked={props.cardIdCalendarClicked}
            />
          }
        </div>
      </div>
      <div className={classNames(
        'course-reg__cell reg-desc',
        { 'empty': !description },
      )}>
        <div className={classNames(
          'course-reg__p-container',
          { 'shown': isDescShown },
        )}>
          {isDescShown &&
            <CloseSubPopup closeHandler={onCloseDescClick}/>}
          <p className={`txt ${uniqueId}`}>{description}</p>
        </div>
        {description && description.trim() && isConditionForHiddenDescription &&
          <ShowMoreButton handler={onShowMoreClick}/>}
      </div>
      <div className="course-reg__cell reg-price">
        <p className="title">{priceStr}</p>
      </div>
      <div className="course-reg__cell reg-btn">{btn}</div>
    </div>
  );
};

export default Card;
